import { useState } from "react";

import type { Asset } from "../api/types";
import { PanelAssets } from "./PanelAssets";
import { PanelBrandKit } from "./PanelBrandKit";
import estilos from "./SeccionMarca.module.css";

interface Props {
  token: string;
  proyectoId: string;
}

// Contenedor de M5b: assets del proyecto + kit de marca. Dos recursos
// independientes (GET /assets, GET /brand-kit) que se cruzan solo para
// mostrar la miniatura del logo actual -- PanelAssets es la unica fuente de
// la lista de assets (se la pasa a PanelBrandKit) y avisa via
// `disparadorMarca` cuando conviene refrescar el kit de marca (subida o
// borrado de un asset tipo "logo", que el backend deriva automaticamente).
export function SeccionMarca({ token, proyectoId }: Props): JSX.Element {
  const [assets, setAssets] = useState<Asset[]>([]);
  const [disparadorMarca, setDisparadorMarca] = useState(0);

  const alCambiarAssets = (
    siguiente: Asset[],
    posibleCambioLogo: boolean,
  ): void => {
    setAssets(siguiente);
    if (posibleCambioLogo) setDisparadorMarca((n) => n + 1);
  };

  return (
    <div className={estilos.grid}>
      <PanelAssets
        token={token}
        proyectoId={proyectoId}
        onCambio={alCambiarAssets}
      />
      <PanelBrandKit
        token={token}
        proyectoId={proyectoId}
        assets={assets}
        disparadorRefresco={disparadorMarca}
      />
    </div>
  );
}
